import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
export type OnNotificationReceivedSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type OnNotificationReceivedSubscription = { __typename?: 'Subscription', onNotificationReceived: { __typename?: 'NotificationReceivedEvent', tenantId: string, notificationId: string, recipientEmail: string } };


export const OnNotificationReceivedDocument = new TypedDocumentString(`
    subscription OnNotificationReceived {
  onNotificationReceived {
    tenantId
    notificationId
    recipientEmail
  }
}
    `);
